export const AppConstants = {
  RemittanceProgressStepperData: [
    { id: 1, stepName: "Amount", pathName: "/send/calculator" },
    { id: 2, stepName: "Remitter", pathName: "send/remitter" },
    { id: 3, stepName: "Recipient", pathName: "send/recipient" },
    { id: 4, stepName: "Documents", pathName: "send/documents" },
    { id: 5, stepName: "Review", pathName: "send/review" },
    { id: 6, stepName: "Payment", pathName: "send/payment" },
  ],
  RemittanceCountryList: [
    { countryName: "United States", currencyName: "USD" },
    { countryName: "Europe", currencyName: "EUR" },
    { countryName: "United Kingdom", currencyName: "GBP" },
    { countryName: "Canada", currencyName: "CAD" },
    { countryName: "Australia", currencyName: "AUD" },
    { countryName: "Singapore", currencyName: "SGD" },
    // { countryName: "Australia", currencyName: "AUD" },
    { countryName: "United Arab Emirates", currencyName: "AED" },
    // { countryName: "Mauritius", currencyName: "MUR" },
    { countryName: "Japan", currencyName: "JPY" },
    { countryName: "New Zeeland Dollars", currencyName: "NZD" },
    { countryName: "Swiss Franc", currencyName: "CHF" },
  ],
  RemittanceSouceOfFunds: [
    {
      value: "salary or wages",
      label: "Salary or Wages",
    },
    {
      value: "student loan",
      label: "Student Loan",
    },
    {
      value: "investments",
      label: "Investments",
    },
    {
      value: "personal savings",
      label: "Personal Savings",
    },
    {
      value: "personal wealth",
      label: "Personal Wealth",
    },
    {
      value: "retirement funds",
      label: "Retirement Funds",
    },
    {
      value: "business owner/share holder",
      label: "Business Owner/Share Holder",
    },
  ],
  RelationshipsList: [
    "Self",
    "Spouse",
    "Mother",
    "Father",
    "Son",
    "Daughter",
    "Brother",
    "Sister",
    "Son-in-law",
    "Daughter-in-law",
    "Others",
  ],
  CountryOfResidence: [
    "United States",
    "United Kingdom",
    "Canada",
    "United Arab Emirates",
    "Singapore",
    "Australia",
    "Germany",
    "New Zealand",
    "France",
    "Italy",
    "Afghanistan",
    "Åland Islands",
    "Albania",
    "Algeria",
    "American Samoa",
    "AndorrA",
    "Angola",
    "Anguilla",
    "Antarctica",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Bouvet Island",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Congo, The Democratic Republic of the",
    "Cook Islands",
    "Costa Rica",
    "Cote D'Ivoire",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands (Malvinas)",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Gambia",
    "Georgia",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and Mcdonald Islands",
    "Holy See (Vatican City State)",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "Indonesia",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, Republic of",
    "Kuwait",
    "Kyrgyzstan",
    "Lao People'S Democratic Republic",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libyan Arab Jamahiriya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Macedonia, The Former Yugoslav Republic of",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia, Federated States of",
    "Moldova, Republic of",
    "Monaco",
    "Mongolia",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "Netherlands Antilles",
    "New Caledonia",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territory, Occupied",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Reunion",
    "Romania",
    "Russia",
    "RWANDA",
    "Saint Helena",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia and Montenegro",
    "Seychelles",
    "Sierra Leone",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Georgia and the South Sandwich Islands",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Taiwan, Province of China",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "United States Minor Outlying Islands",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Viet Nam",
    "Virgin Islands, British",
    "Virgin Islands, U.S.",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ],
  IbanCountryArray: [
    "Germany",
    "France",
    "United Kingdom",
    "Belgium",
    "United Arab Emirates",
    "Italy",
    "Brazil",
    "Portugal",
  ],
  codeCountry: ["Australia", "Canada", "United Kingdom", "United States"],
};
